import { useState, useEffect, ReactNode, FC } from 'react';

import { data as fr } from './translations/fr-FR';
import { LocaleContext } from './context';
import { LocaleData } from '../../models/locale/locale-data';
import { Locales } from '../../models/locale/locales';
import { getTranslation } from '../../utils/translation/get';

const localePaths: Record<Locales, LocaleData> = {
  'fr-FR': fr,
};

// Default app locale set to 'fr-FR' as website only applicable to French market.
const baseLocale: Locales = 'fr-FR';

export const LocaleProvider: FC<{
  children: ReactNode;
  environment: 'sandbox' | 'development' | 'qa' | 'production';
}> = ({ children, environment = import.meta.env.MODE ?? 'production' }) => {
  const [locale, setLocaleState] = useState(getTranslation);
  const [data, setData] = useState<LocaleData | null>(null);

  const setLocale = (newLocale: Locales) => {
    setLocaleState(newLocale);
  };

  const isValidLocale = (locale: Locales): boolean => Object.keys(localePaths).includes(locale);

  useEffect(() => {
    const loadData = async () => {
      // Validate locale against locale paths list otherwise fallback to default
      const data = isValidLocale(locale) ? localePaths[locale] : localePaths[baseLocale];
      if (data) setData(data);
      else {
        if (environment !== 'production') {
          console.error(`Locale data for "${locale}" could not be loaded.`);
        }
      }
    };
    loadData();
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, setLocale, data }}>{children}</LocaleContext.Provider>
  );
};
